import { combineReducers } from 'redux-immutable';

import tasksReducer from 'features/projects/tasks/tasks.reducer';
import taskReducer from 'features/projects/tasks/task/task.reducer';

export default combineReducers({
  tasks: tasksReducer,
  task: taskReducer,
});
